'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _themeSections = require('@shopify/theme-sections');

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _utils = require('../helpers/utils');

var _toggle = require('../components/toggle');

var _toggle2 = _interopRequireDefault(_toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Section: Menu drawer
 * -----------------------------------------------------------------------------
 * Scripts to initiate menu drawer toggle and also display on admin
 *
 * @namespace menuDrawer
 */
var selectors = {
  childMenuToggle: '[js-menu-drawer="childMenuToggle"]',
  grandChildMenuToggle: '[js-menu-drawer="grandChildMenuToggle"]',
  siteMenu: '[js-site-header="container"]'
};

/**
 * Instantiate menu drawer toggle.
 */
var MenuDrawer = (0, _toggle2.default)({
  toggleSelector: 'menuDrawerToggle',
  targetSelector: 'menuDrawerTarget',
  focusInput: false,
  overlay: false
});

/**
 * Component selectors.
 */
var menus = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.childMenuToggle)), (0, _toConsumableArray3.default)(document.querySelectorAll(selectors.grandChildMenuToggle)));

(0, _themeSections.register)('menu-drawer', {

  /**
   * Initiate toggle events on all sub-menus.
   */
  constructAccordionMenus: function constructAccordionMenus() {
    var _this = this;

    [].concat((0, _toConsumableArray3.default)(menus)).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return _this.onItemClick(event, element);
      });
    });
  },


  /**
   * Component selectors.
   */
  setNodeSelectors: function setNodeSelectors() {
    this.siteMenu = document.querySelector(selectors.siteMenu);
  },


  /**
   * Handle toggle event on menu item click.
   * @param {Event} event - Click event.
   * @param {HTMLElement} element - The menu item.
   */
  onItemClick: function onItemClick(event, element) {
    event.preventDefault();
    this.toggleElement(element);
    this.toggleElement((0, _utils.getSiblings)(element)[0]);
  },


  /**
   * Check if item is active.
   * @param {HTMLElement} element - The menu item.
   */
  isItemActive: function isItemActive(element) {
    return element.classList.contains(_cssClasses2.default.active);
  },


  /**
   * Toggle button state.
   * @param {HTMLElement} element - The toggled button.
   */
  toggleElement: function toggleElement(element) {
    if (this.isItemActive(element)) {
      this.showMenu(element);
      return;
    }
    this.hideMenu(element);
  },


  /**
   * Show menu.
   * @param {HTMLElement} element - The item to show.
   */
  showMenu: function showMenu(element) {
    element.classList.remove(_cssClasses2.default.active);
  },


  /**
   * Hide menu.
   * @param {HTMLElement} element - The item to hide.
   */
  hideMenu: function hideMenu(element) {
    element.classList.add(_cssClasses2.default.active);
  },


  /**
   * Add class to header on menu open. Make sure background is white
   */
  eventListeners: function eventListeners() {
    var _this2 = this;

    Frame.EventBus.listen('Toggle:menuDrawerTarget:open', function () {
      window.theme.features.disableClearHeader = true;
      _this2.siteMenu.classList.add('menu-active');
      _this2.siteMenu.classList.remove(_cssClasses2.default.headerClear);
    });
    Frame.EventBus.listen('Toggle:menuDrawerTarget:close', function () {
      window.theme.features.disableClearHeader = false;
      _this2.siteMenu.classList.remove('menu-active');
      _this2.siteMenu.classList.add(_cssClasses2.default.headerClear);
    });
  },


  /**
   * Initialise section.
   */
  init: function init() {
    MenuDrawer.init();
    this.constructAccordionMenus();
    this.setNodeSelectors();
    this.eventListeners();
  },


  /**
    * Event callback for Theme Editor `section:select` event
    */
  onSelect: function onSelect() {
    MenuDrawer.open();
  },


  /**
    * Event callback for Theme Editor 'shopify:section:deselect' event.
    */
  onDeselect: function onDeselect() {
    MenuDrawer.close();
  },


  /**
   * Event callback for Theme Editor `section:load` event
   */
  onLoad: function onLoad() {
    this.init();
  }
});